<div class="p-2 espacamento-formulario-mobile">
  <div class="col-md-12 col-sm-12 mt-1">
    <div class="card-content col-md-12 col-sm-12 mt-1">
      <!-- *ngIf="formEntidadeSomenteLeitura" -->
      <div class="mb-1">
        <h4 class="col-12 text-center titulo p-1 mt-1" style="background: black; color: #fff; border-radius: 10px">
          FORMULÁRIO DE INSCRIÇÃO DA ENTIDADE - {{ nomeEntidade }}
        </h4>
      </div>
      <!-- <pre>{{ this.nomeEntidade | json }}</pre> -->
      <form [formGroup]="formularioInscricaoEntidade">
        <!-- Seção do Tipo de Servidor -->
        <div class="form-group mb-3">
          <div>
            <h4 class="form-section">
              <i class="ft-user"></i>
              <b>SERVIDOR</b>
            </h4>
          </div>

          <div class="row">
            <div class="col-12 col-md-6 col-lg-4" *ngFor="let type of ListaServidores">
              <div class="d-flex align-items-center mb-2">
                <input
                  name="server"
                  type="radio"
                  formControlName="server"
                  [value]="type.value"
                  [id]="'server' + type.value"
                  class="me-2" />
                <label [for]="'server' + type.value" class="mb-0">{{ type.description }}</label>
              </div>
            </div>
          </div>
        </div>

        <!-- Seção de Dados Cadastrais -->
        <div class="form-group mb-3">
          <div class="row">
            <div class="col-12">
              <h4 class="form-section">
                <i class="ft-user"></i>
                <b>DADOS CADASTRAIS</b>
              </h4>
            </div>
          </div>

          <!-- Linha 1: Nome e Data de Nascimento -->
          <div class="row">
            <div class="form-group col-md-5">
              <label for="name">Nome Completo</label>
              <input
                type="text"
                class="form-control round"
                id="name"
                formControlName="name"
                [ngClass]="{
                  'is-invalid':
                    formularioInscricaoEntidade.get('name')?.invalid && formularioInscricaoEntidade.get('name')?.touched
                }" />

              <app-validacao-form-input
                [nomeFormulario]="formularioInscricaoEntidade"
                nomeCampo="name"
                [maxLength]="250"
                [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
            </div>

            <div class="col-12 col-sm-12 mb-2 col-md-4">
              <label for="birthDate">Data de Nascimento</label>
              <div class="input-group">
                <input
                  #datepicker="bsDatepicker"
                  bsDatepicker
                  name="birthDate"
                  maxlength="10"
                  type="text"
                  class="form-control round bg-white"
                  id="birthDate"
                  [minDate]="minDate"
                  [maxDate]="maxDate"
                  [bsConfig]="bsConfig"
                  formControlName="birthDate"
                  [ngClass]="{
                    'is-invalid': formularioInscricaoEntidade.controls['birthDate'].errors && isFormSubmited
                  }" />

                <div *ngif="!formEntidadeSomenteLeitura" class="input-group-append">
                  <button class="btn btn-secondary round botao-calendario" type="button" (click)="datepicker.show()">
                    <i class="fa fa-calendar"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="form-group col-sm-12 col-md-3">
              <label for="civilStatusId">Estado Civil</label>
              <ng-select
                [multiple]="false"
                [loading]="false"
                [closeOnSelect]="true"
                [searchable]="true"
                class="round shadow"
                formControlName="civilStatusId"
                [ngClass]="{
                  'is-invalid': formularioInscricaoEntidade.controls['civilStatusId'].errors && isFormSubmited
                }"
                notFoundText="Nenhum registro localizado">
                <ng-option *ngFor="let estadoCivil of listaEstatusCivil" [value]="estadoCivil.id">
                  {{ estadoCivil.name }}
                </ng-option>
              </ng-select>
              <app-validacao-form-input
                [nomeFormulario]="formularioInscricaoEntidade"
                nomeCampo="civilStatusId"
                [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
            </div>
          </div>

          <!-- Linha 2: CPF, RG e Sexo -->
          <div class="row">
            <div class="form-group col-md-4">
              <label for="cpf">CPF</label>
              <input
                name="cpf"
                [showMaskTyped]="true"
                mask="000.000.000-00"
                formControlName="cpf"
                class="form-control border-radius"
                [ngClass]="{
                  'is-invalid': formularioInscricaoEntidade.controls['cpf'].errors && isFormSubmited
                }"
                id="cpf" />
              <app-validacao-form-input
                [nomeFormulario]="formularioInscricaoEntidade"
                nomeCampo="cpf"
                [maxLength]="250"
                [minLength]="10"
                [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
            </div>

            <div class="form-group col-md-4">
              <label for="rg">RG</label>
              <input
                name="rg "
                [showMaskTyped]="true"
                mask="AA.AAA.AAA-A"
                formControlName="rg"
                class="form-control border-radius"
                [ngClass]="{
                  'is-invalid': formularioInscricaoEntidade.controls['rg'].errors && isFormSubmited
                }"
                id="rg" />
              <app-validacao-form-input
                [nomeFormulario]="formularioInscricaoEntidade"
                nomeCampo="rg"
                [maxLength]="12"
                [minLength]="10"
                [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
            </div>

            <div class="form-group mb-1 col-sm-12 col-md-4 campo-sexo-tablet">
              <label for="sex">Sexo</label>
              <br />

              <input
                [ngClass]="{
                  'is-invalid': formularioInscricaoEntidade.controls['sex'].errors && isFormSubmited
                }"
                formControlName="sex"
                [value]="1"
                id="active"
                type="radio"
                class="me-2"
                name="sex"
                checked />
              <label class="mb-0">Masculino</label>

              <input
                [ngClass]="{
                  'is-invalid': formularioInscricaoEntidade.controls['sex'].errors && isFormSubmited
                }"
                formControlName="sex"
                [value]="2"
                id="Inactive"
                type="radio"
                class="me-2"
                name="sex" />
              <label class="mb-0">Feminino</label>

              <app-validacao-form-input
                [nomeFormulario]="formularioInscricaoEntidade"
                nomeCampo="sex"
                [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
            </div>
          </div>

          <!-- Linha 3: E-mail e Telefones -->
          <div class="row">
            <div class="form-group mb-1 col-sm-12 col-md-5">
              <label for="email">E-mail</label>
              <input
                type="text"
                class="form-control round"
                id="email"
                formControlName="email"
                [maxlength]="249"
                [ngClass]="{
                  'is-invalid': formularioInscricaoEntidade.controls['email'].errors && isFormSubmited
                }" />
              <app-validacao-form-input
                [nomeFormulario]="formularioInscricaoEntidade"
                nomeCampo="email"
                [maxLength]="250"
                [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
              <div
                class="errors"
                *ngIf="
                  formularioInscricaoEntidade.get('email')?.invalid &&
                  (formularioInscricaoEntidade.get('email')?.touched || formularioInscricaoEntidade.get('email')?.dirty)
                ">
                <div class="errors" *ngIf="formularioInscricaoEntidade.get('email')?.hasError('checkEmail')">
                  {{ formularioInscricaoEntidade.get('email')?.errors?.['checkEmail'] }}
                </div>
              </div>
            </div>

            <!-- Telefone Comercial-->
            <div class="form-group col-md-2 col-sm-12 tamanho-campo-medio-tablet">
              <label for="businessPhone">Telefone Comercial</label>
              <input
                mask="(00) 0000-0000"
                [showMaskTyped]="true"
                class="round form-control"
                formControlName="businessPhone"
                [ngClass]="{
                  'is-invalid': formularioInscricaoEntidade.controls['businessPhone'].errors && isFormSubmited
                }"
                type="text" />
              <app-validacao-form-input
                [nomeFormulario]="formularioInscricaoEntidade"
                nomeCampo="businessPhone"
                [maxLength]="250"
                [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
            </div>
            <!-- Telefone Residencial-->
            <div class="form-group col-md-3 col-sm-12 tamanho-campo-medio-tablet">
              <label for="homePhone">Telefone Residencial</label>
              <input
                mask="(00) 0000-0000"
                [showMaskTyped]="true"
                class="round form-control"
                formControlName="homePhone"
                [ngClass]="{'is-invalid': formularioInscricaoEntidade.controls['homePhone'].errors && isFormSubmited}"
                type="text" />
              <app-validacao-form-input
                [nomeFormulario]="formularioInscricaoEntidade"
                nomeCampo="homePhone"
                [maxLength]="250"
                [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
            </div>
            <!-- Celular -->
            <div class="form-group col-md-2 col-sm-12 mb-2 tamanho-campo-medio-tablet">
              <label for="mobilePhone">Celular</label>
              <input
                mask="(00) 00000-0000"
                [showMaskTyped]="true"
                class="round box-shadow-4 form-control"
                formControlName="mobilePhone"
                type="text"
                [ngClass]="{
                  'is-invalid': formularioInscricaoEntidade.controls['mobilePhone'].errors && isFormSubmited
                }" />
              <app-validacao-form-input
                [nomeFormulario]="formularioInscricaoEntidade"
                nomeCampo="mobilePhone"
                [maxLength]="250"
                [isFormSubmited]="isFormSubmited"></app-validacao-form-input>
            </div>
          </div>

          <!-- Linha 4: Endereço -->
          <div class="form row">
            <div class="col-md-12 col-sm-12 mt-1">
              <!-- Dados de Endereço -->
              <app-endereco
                [estaAberto]="true"
                [ocultarComplemento]="true"
                [estaAberto]="true"
                [ocultarBtnAcao]="true"
                [mostrarTipoEndereco]="true"
                [tipoEnderecoObrigatorio]="true"
                [ocultarTabela]="true"></app-endereco>
            </div>
          </div>
          <!-- Botão de Confirmação -->
          <div *ngIf="!formEntidadeSomenteLeitura" class="modal-footer d-flex mt-4 espacamento-formulario-mobile">
            <div class="col-12 text-right espacamento-formulario-mobile">
              <button type="button" class="btn mr-2 btn-success round box-shadow-4" (click)="salvar()">
                <i class="ft-thumbs-up"></i>
                Confirmar
              </button>
              <button (click)="fechar()" type="button" class="btn btn-warning round box-shadow-4">
                <i class="ft-thumbs-down"></i>
                Fechar
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
